// extracted by mini-css-extract-plugin
export default {"mainBlock":"main_mainBlock__1cZXk","active":"main_active__aIqOe"};